import { render, staticRenderFns } from "./dejhglInfo.vue?vue&type=template&id=3db5ca75&scoped=true"
import script from "./dejhglInfo.vue?vue&type=script&lang=js"
export * from "./dejhglInfo.vue?vue&type=script&lang=js"
import style0 from "./dejhglInfo.vue?vue&type=style&index=0&id=3db5ca75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db5ca75",
  null
  
)

export default component.exports